<template>
  <div class="payresult-bg">
    <div class="payresult-top">

    </div>
    <div class="payresult">
      <img src="../../assets/pay/pay_success.png" width="60" height="60">
      <span class="pay-text">充值完成</span>
      <el-button type="success" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
export default{
  name: 'PayResult',
  data () {
    return {

    }
  },
  methods: {
    backClick: function () {

    }
  }
}
</script>

<style scoped>
  .payresult-bg{
    width: 100%;
    height: 100%;
  }
  .payresult-top{
    height: 50px;
  }
  .payresult{
    padding: 20px;
    width: 300px;
    background-color: #ffffff;
    margin:0 auto 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .pay-text{
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/page/financedManager/PayResult.vue